module.exports = __webpack_public_path__ + "img/medical.d07688dd.jpg";